import React, { useState } from 'react';
import VoucherForm from './VoucherForm';
import VoucherPDF from './VoucherPDF';
import styled from "styled-components";

const Contenedor = styled.div`
  margin-bottom: 60px;
`

const VoucherApp = () => {
  const [voucherGenerado, setVoucherGenerado] = useState(null);

  const generarVoucher = (voucherData) => {
    // Seteamos el voucher generado para que el componente VoucherPDF lo utilice
    setVoucherGenerado(voucherData);
  };

  return (
    <Contenedor>
        <VoucherForm generarVoucher={generarVoucher} />
        {voucherGenerado && <VoucherPDF voucherData={voucherGenerado} />}
    </Contenedor>
  );
};

export default VoucherApp;
